<!--================================= Header Start =================================-->
<div class="header-main" [class.sticky]="isSticky()" [class.hidden]="isHidden()">
  <div class="header-inner">
    <nav class="navbar navbar-expand-lg" [class.border-0]="router.url.includes('/' + ROUTES.ACCOUNT.ROOT)">
      <div class="container-fluid">
        <!--  Mobile & Tablet View -->
        <!-- Logo (Navbar Brand) -->
        <a class="navbar-brand d-none" routerLink="/">
          <img [src]="s3BucketImageURL + '/ASSETS/GENERAL/LOGO/responsive-logo.svg'" width="23" height="35"
            alt="GatherCo" appHandleImageError />
        </a>
        <!-- Logo (Navbar Brand) -->
        <!-- Right-Side Menu -->
        <div class="right-side-manu d-none">
          <div class="d-flex align-items-center" role="search">
            <!-- Search Box -->
            @if (showSearchBar) {
            <div class="search-icon" [class.mobile-icon-hide]="isUserAuthenticated">
              <input #searchInput type="search" placeholder="Search" class="search-box"
                (focus)="isSearchActive.set(true)"
                (keydown.enter)="onSearch($event, searchInput.value); isSearchActive.set(false)"
                (blur)="isSearchActive.set(false)" />
            </div>
            }
            <!-- Sign In Button for Non-Authenticated Users -->
            @if (isUserAuthenticated == false) {
            <div class="responsive-sign-in-btn">
              <ng-container *ngTemplateOutlet="signIn"></ng-container>
            </div>
            }
            @if (isUserAuthenticated) {
            <ng-container *ngTemplateOutlet="searchIcons; context: { $implicit: true }"></ng-container>
            }
          </div>
          <!-- Navbar Toggler for Mobile View -->
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" #menuIcon
            data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
            aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
        </div>
        <!-- Right-Side Menu -->
        <!--  Mobile & Tablet View -->

        <!-- Desktop View -->
        <!-- Main Navbar Content -->
        <div class="collapse navbar-collapse justify-content-between align-item-center navbar-list"
          id="navbarSupportedContent">
          <!-- Navbar Brand -->
          <a class="navbar-brand" routerLink="/">
            <img [src]="s3BucketImageURL + '/ASSETS/GENERAL/LOGO/gatherco-logo.svg'" width="143" height="55"
              alt="GatherCo" appHandleImageError />
          </a>
          <ul class="navbar-nav mb-2 mb-lg-0" [class.hide-nav]="isSearchActive()">
            @if (isUserAuthenticated) {
            <li class="nav-item d-none">
              <a class="nav-link" (click)="toggleMenu()"
                [routerLink]="[ROUTES.ACCOUNT.ROOT+'/'+ROUTES.ACCOUNT.DASHBOARD]" routerLinkActive="active">
                Dashboard
              </a>
            </li>
            }
            <li class="nav-item">
              <a class="nav-link" routerLink="flooring" (click)="toggleMenu()"
                (mouseover)="onMouseEnterMenu('flooring', $event)" routerLinkActive="active"
                aria-current="page">Flooring</a>
              <ng-container
                *ngTemplateOutlet="megaMenu; context: { type: 'Flooring', collections: flooringCollectionList, typeName: flooringTypeName }"></ng-container>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="walling" (click)="toggleMenu();"
                (mouseover)="onMouseEnterMenu('walling', $event)" routerLinkActive="active">Walling</a>
              <ng-container
                *ngTemplateOutlet="megaMenu; context: { type: 'Walling', collections: wallingCollectionList, typeName: wallingTypeName }"></ng-container>
            </li>
            <li class="nav-item custom-dropdown" [routerLinkActive]="'is-active'"
              [routerLinkActiveOptions]="{ exact: false }">
              <div class="dropdown">
                <a href="" class="nav-link manu-icon dropdown-toggle" id="aboutUsDropdown" data-bs-toggle="dropdown"
                  aria-expanded="false">
                  About Us
                </a>
                <ul class="dropdown-menu" aria-labelledby="aboutUsDropdown" (click)="toggleMenu()">
                  @for (item of dropDownList; track item.title) {
                  <li><a class="dropdown-item" [routerLink]="item.route" routerLinkActive="active">{{item.title}}</a>
                  </li>
                  }
                </ul>
              </div>
            </li>
            <li class="nav-item">
              <a class="nav-link" (click)="toggleMenu()" routerLink="projects" routerLinkActive="active">
                Projects
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="sample-request" (click)="toggleMenu()" routerLinkActive="active">
                Sample Request
              </a>
            </li>
            <!-- <li class="nav-item">
              <a class="nav-link" (click)="isUserAuthenticated ? handlePriceListClick() : null" [routerLink]="isUserAuthenticated ? [ROUTES.PRICE_LIST] : null" routerLinkActive="active" [class.grey-price-menu]="!isUserAuthenticated" placement="auto" [ngbTooltip]="!isUserAuthenticated ? CommonConstants.PRICE_MENU_TOOLTIP_MESSAGE : ''">
                Price List
              </a>
            </li> -->
            <li class="nav-item">
              @if (isUserAuthenticated == false) {
              <span class="nav-link grey-price-menu" placement="auto"
                [ngbTooltip]="CommonConstants.PRICE_MENU_TOOLTIP_MESSAGE">
                Price List
              </span>
              } @else if (isUserAuthenticated) {
              <a class="nav-link" (click)="handlePriceListClick()" [routerLink]="[ROUTES.PRICE_LIST]"
                routerLinkActive="active">
                Price List
              </a>
              }
            </li>

            <li class="nav-item">
              <a class="nav-link outlet" (click)="toggleMenu()" [routerLink]="[ROUTES.OUTLET.ROOT]"
                routerLinkActive="active">
                Outlet
              </a>
            </li>
            @if (isUserAuthenticated) {
            <ng-container *ngTemplateOutlet="dropdown; context: { $implicit: true }"></ng-container>
            }
          </ul>
          <!-- Navbar Links -->
          <!-- Search and User Icons -->
          <div class="d-flex align-items-center navbar-right" role="search" [class.expanded-search]="isSearchActive()">
            @if (showSearchBar) {
            <div class="search-icon">
              <input #searchValue type="search" placeholder="Search" class="search-box"
                (focus)="isSearchActive.set(true);" (blur)="isSearchActive.set(false);"
                (keyup.enter)="onSearch($event, searchValue.value);  isSearchActive.set(false)" />
            </div>
            }
            <!-- Authentication Buttons -->
            @if (isUserAuthenticated == false) {
            <ng-container *ngTemplateOutlet="signIn"></ng-container>
            } @else if (isUserAuthenticated) {
            <ng-container *ngTemplateOutlet="searchIcons"></ng-container>
            }
          </div>
        </div>
        <!-- Main Navbar Content -->
        <!-- Desktop View -->
        <ng-template #megaMenu let-type="type" let-collections="collections" let-typeName="typeName">
          <div class="mega-menu">
            <div class="mega-menu-inner">
              <div class="left-side">
                <a [routerLink]="type.toLowerCase()" class="mega-menu-link" (click)="toggleMegaMenu($event)">All
                  {{type}}
                  <img [src]="s3BucketImageURL + '/ASSETS/GENERAL/ICONS/right-arrow-icon.svg'" width="18" height="14"
                    alt="Right Arrow Icon" appHandleImageError>
                </a>
              </div>
              <div class="right-side">
                <ul class="right-side-content">
                  @for (collection of collections; track collection.name) {
                  <li class="menu-nav-item">
                    <a class="menu-nav-link" (click)="toggleMegaMenu($event)"
                      [routerLink]="['/'+ utilityService.createSlug(typeName)+'/'+utilityService.createSlug(collection.name)]">
                      {{ collection.name }}
                    </a>
                  </li>
                  } @empty {
                  <li>No data found.</li>
                  }
                </ul>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template #searchIcons let-show>
          <div class="search-icons d-flex align-items-center ms-2">
            <ng-container
              *ngTemplateOutlet="gathercoCredit; context: { $implicit: show ? true : false }"></ng-container>
            @if (showSearchBar && show) {
            <div class="search-icon mobile-icon-show">
              <input #searchInput type="search" placeholder="Search" class="search-box"
                (focus)="isSearchActive.set(true);" (blur)="isSearchActive.set(false);"
                (keydown.enter)="onSearch($event, searchInput.value);  isSearchActive.set(false);" />
            </div>
            }
            @for (icon of iconList; track icon.title) {
              @if (icon.title!='Samples' || (icon.title=='Samples' && sampleOrderCount() && !subscriberService.sampleOrderError())) {
                <a routerLinkActive="active" class="manu-icon"
                  [class.mobile-icon-hide]="icon.title=='Trade Dashboard' && show" [routerLink]="icon.route" (click)="icon.title=='Samples' ? openSampleOrderModal() : null">
                  <img [src]="s3BucketImageURL + icon.icon" [width]="icon.width ? icon.width : show ? 24 : 22"
                    [height]="show ? 24 : 22" [alt]="icon.title" class="icon" [title]="icon.title" />
                  @if(icon.title=='Samples') {
                  <span class="badges">{{ sampleOrderCount() }}</span>
                  }
                  @if(icon.count) {
                  <span class="badges">{{ icon.count }}</span>
                  }
                </a>
              }
            }
            <!-- User Profile Dropdown -->
            <div class="dropdown d-inline-block dropstart" [class.mobile-icon-hide]="show">
              <a href="" class="manu-icon dropdown-toggle" title="User Profile" id="userDropdown"
                data-bs-toggle="dropdown" aria-expanded="false">
                <img [src]="s3BucketImageURL + '/ASSETS/GENERAL/ICONS/user-icon.svg'" [width]="show ? 24 : 22"
                  [height]="show ? 24 : 22" alt="User Icon" class="icon" />
              </a>
              <ul class="dropdown-menu" aria-labelledby="userDropdown">
                <ng-container *ngTemplateOutlet="dropdown"></ng-container>
              </ul>
            </div>
          </div>
        </ng-template>
        <ng-template #gathercoCredit let-showClass>
          @if(isCreditEarnDisabled==CommonConstants.CREDIT_EARN.SHOW){
          <div class="gatheco-credit-box">
            <a class="gatheco-credit" [class.custom-margin]="!showSearchBar && showClass"
              [routerLink]="[ROUTES.ACCOUNT.ROOT + '/' + ROUTES.ACCOUNT.THE_GATHER_COMMITMENT]" placement="bottom"
              ngbTooltip="GatherCo Credit">
              <img [src]="s3BucketImageURL + '/ASSETS/GENERAL/ICONS/credit-coin-icon.svg'" loading="lazy"
                alt="Credit Icon" width="22" height="22" title="GatherCo Credit">
              <label class="credit-label"><span class="credit-content"> </span><strong class="credit">{{
                  gathercoCreditCount | currency
                  }}</strong></label>
            </a>
          </div>
          }
        </ng-template>
        <ng-template #signIn>
          <button class="btn btn-secondary" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal"
            (click)="openModal()">
            <span class="btn-secondary-hover"></span>
            <span class="btn-content">Sign In</span>
          </button>
        </ng-template>
        <ng-template #dropdown let-link>
          <li [class.nav-item]="link" [class.d-none]="link">
            <a [class.nav-link]="link" [class.dropdown-item]="!link" (click)="link ? toggleMenu() : null"
              [routerLink]="[ROUTES.ACCOUNT.ROOT+'/'+ROUTES.ACCOUNT.ACCOUNT_SETTINGS]">
              My Profile
            </a>
          </li>
          <li [class.nav-item]="link" [class.d-none]="link">
            <span [class.nav-link]="link" [class.dropdown-item]="!link"
              (click)="openModal(CommonConstants.AUTH_MODAL_TYPES.CHANGE_PASSWORD); link ? toggleMenu() : null">
              Change Password
            </span>
          </li>
          @if(!link) {
          <li>
            <hr class="dropdown-divider" />
          </li>
          }
          <li [class.nav-item]="link" [class.d-none]="link">
            <span [class.nav-link]="link" [class.dropdown-item]="!link" (click)="logout(); link ? toggleMenu() : null">
              Logout
            </span>
          </li>
        </ng-template>
      </div>
    </nav>
  </div>
</div>
<!--================================= Header End =================================-->
